import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, InfoBox, NavigationButtons } from '../index';
import { selfServiceApi } from '../../services/selfServiceApi';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';
import { formatCurrency } from '../../utils/locale';

const PaymentStep: React.FC = () => {
  const { selfServiceData, goBack, sessionId, history } = useWizard();
  const [redirecting, setRedirecting] = useState(false);
  const [title, setTitle] = useState('Betaling');
  const [body, setBody] = useState<string[] | null>(null);
  const passportFee = 891;

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.payment).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);
  
  const handlePayment = async () => {
    setRedirecting(true);
    // Save state before redirect to payment gateway
    if (sessionId) {
      await selfServiceApi.saveBeforeRedirect(sessionId, {
        selfServiceData,
        currentStepId: 'payment',
        history
      }, 'payment');
    }
    
    // Simulate redirect to payment gateway
    const returnUrl = `${window.location.origin}${window.location.pathname}?sessionId=${sessionId}&return=payment&status=success`;
    console.log('Would redirect to payment gateway with return URL:', returnUrl);
    
    // For test - simulate payment with delay
    setTimeout(() => {
      window.location.href = returnUrl;
    }, 1000);
  };
  
  return (
    <StepContainer title={title}>
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <div className="payment-info">
        <div className="price-box" style={{
          backgroundColor: 'var(--bg-color)',
          padding: '1.5rem',
          borderRadius: 'var(--border-radius)',
          marginBottom: '1.5rem'
        }}>
          <h3>Pris oversigt</h3>
          <p>Pas gebyr: {formatCurrency(passportFee)}</p>
          <p><strong>Total: {formatCurrency(passportFee)}</strong></p>
        </div>
        <button
          className="btn btn-primary"
          onClick={handlePayment}
          disabled={redirecting}
          data-testid="button-pay"
          style={{ marginBottom: '1.5rem' }}
        >
          {redirecting ? 'Simulerer betaling...' : 'Betal'}
        </button>
      </div>
      <NavigationButtons onBack={goBack} showNext={false} />
    </StepContainer>
  );
};

export default PaymentStep;
